// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as RaiseTicketRepo from "./RaiseTicketRepo.bs.js";
import * as DummyRaiseTicketRepo from "./DummyRaiseTicketRepo.bs.js";

function getRaiseTicketRepo(param) {
  if (Config.Env.env === "development") {
    return {
            raiseTicket: DummyRaiseTicketRepo.RaiseTicketRepo.raiseTicket,
            fetchTicketInfo: DummyRaiseTicketRepo.RaiseTicketRepo.fetchTicketInfo,
            fetchTicketIssues: DummyRaiseTicketRepo.RaiseTicketRepo.fetchTicketIssues,
            fetchTicketActions: DummyRaiseTicketRepo.RaiseTicketRepo.fetchTicketActions,
            fetchTicketIssuesV2: DummyRaiseTicketRepo.RaiseTicketRepo.fetchTicketIssuesV2
          };
  } else {
    return RaiseTicketRepo.RaiseTicketRepo;
  }
}

export {
  getRaiseTicketRepo ,
  
}
/* Config Not a pure module */
